import styled from 'styled-components';

export const Input = styled.input`
    font-family: sans-serif;
    font-weight: ${props => (props.modalLabel ? 'normal' : 'bold')};
    border: ${props =>
        props.readOnly
            ? '0px'
            : props.errormask
                ? '1px solid #c1272d'
                : props.modalLabel
                    ? '1px solid rgb(169, 169, 169)'
                    : '1px solid rgb(220, 220, 220)'};
    border-radius: ${props => (props.modalLabel ? '5px' : '0px')};
    height: ${props => (props.login ? '30px' : '20px')};
    display: ${props => props.display};
    text-align: ${props => (props.alignCenter ? `center` : 'left')};
    float: ${props => (props.floatleft ? `left` : 'inherit')};
    background: ${props =>
        props.errormask
            ? `url(${props.background}) no-repeat 98% 50%`
            : 'none'};
    background-color: ${props => (props.white ? 'white' : 'transparent')};
    background-size: 15px auto !important;
    width: ${props =>
        props.smallInput
            ? '15%'
            : props.verysmallInput
                ? '10%'
                : props.width975
                    ? '97.5%'
                    : '100%'};

    &:focus {
        outline: 2px solid #a6c7ff;
    }
    box-sizing: border-box;
    padding-left: 5px;
    color: rgb(40, 40, 45);
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Input.js